import React from "react"
import { Link } from "gatsby"
import uuid from "uuid"
import Navbar from "react-bootstrap/Navbar"
import Nav from "react-bootstrap/Nav"
import NavDropdown from "react-bootstrap/NavDropdown"
import pageLinksData from "./pageLinksData"
import { OutboundLink } from "gatsby-plugin-google-gtag"

import Wrapper from "@components/Wrapper"
import styles from "./PageNavBar.module.scss"

const NavBarContents = props => {
  return (
    <Navbar
      id="navbar"
      expand="xl"
      className={"justify-content-end justify-content-xl-between "}
      fixed="top"
    >
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse className="justify-content-end">
        <Nav
          id="navbar-nav"
          className={
            "text-primary w-100 justify-content-xl-between text-center"
          }
        >
          {pageLinksData.map(pageLinkData => {
            if (pageLinkData.type === "dropdown") {
              const links = [];
              pageLinkData.items.map(item => {
                links.push(<OutboundLink
                  className={"dropdown-item proxima-nova--semi-bold fs-14pt ls-1px text-center"}
                  activeClassName="active"
                  key={uuid()}
                  href={item.href}
                >
                  {item.innerHTML}
                </OutboundLink>)
              });
              return (
                <NavDropdown
                  key={uuid()}
                  title={pageLinkData.innerHTML}
                  className={`proxima-nova--semi-bold fs-14pt ls-1px`}
                  activeClassName="active"
                >
                  {links}
                </NavDropdown>
              )
            }

            return ( 
              <Link
                className={"nav-link proxima-nova--semi-bold fs-14pt ls-1px"}
                key={uuid()}
                to={pageLinkData.href}
                activeClassName="active"
              >
                {pageLinkData.innerHTML}
              </Link>
            )
          })}
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  )
}

const PageNavBar = props => {
  return (
      <NavBarContents></NavBarContents>
  )
}

export default PageNavBar